import React, { Children, isValidElement } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { sortChildrenByPropName } from '../../utils/sort-children-by-prop-name.js';
import { SortableAPI } from './sortable-api.js';
import './sortable.css';
const SortableContainer = {
    name: '',
};
const awesomeProps = {
    api: SortableAPI,
    containers: [SortableContainer],
    type: ComponentType.BEHAVIOR,
};
const IDENTIFIER = 'identifier';
function filterValidChildren(props) {
    return Children.toArray(props.children)
        .filter(child => isValidElement(child) && props.order.includes(child.props[IDENTIFIER]));
}
/**
 * Behavioral component that when used in combination with the Identifiable component applies
 * a custom order to its children.
 *
 * @param props - Props used to render the component.
 */
function Sortable(props) {
    const validChildren = filterValidChildren(props);
    const children = sortChildrenByPropName(validChildren, IDENTIFIER, props.order);
    return (React.createElement(Container, { className: "c-sortable", uuid: props.uuid }, children));
}
Sortable.propTypes = {
    children: arrayOf(element),
    order: arrayOf(string),
};
Sortable.defaultProps = {
    order: [],
};
AwesomeComponent(awesomeProps)(Sortable);
export { Sortable, };
//# sourceMappingURL=sortable.js.map